const MAX_DIGITS = 15;

const extractCents = (value: string): string =>
  value.replace(/\D/g, '').replace(/^0+/, '').slice(0, MAX_DIGITS);

export const maskCurrency = (rawValue: string): string => {
  const cents = extractCents(rawValue);

  if (!cents) return '';

  return (Number(cents) / 100).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const unmaskCurrency = (maskedValue: string): number | null => {
  const cents = extractCents(maskedValue);

  return cents ? Number(cents) / 100 : null;
};
